module.exports = __webpack_public_path__ + "static/middle-range-theories-1bdb918a1901ea66b5f96daf29145d58.jpg";